import axios from "axios";
window.axios = axios;

// Set default headers
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.headers.common['Content-Type'] = 'application/json';

// Set CSRF token for web routes (not needed for API routes)
const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

// Set API token from localStorage if exists
const apiToken = localStorage.getItem('api_token');
if (apiToken) {
    window.axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
}

// Add request interceptor to log requests for debugging
window.axios.interceptors.request.use(request => {
    console.log('Starting Request:', request);
    return request;
});

// Add response interceptor to log responses for debugging
window.axios.interceptors.response.use(
    response => {
        console.log('Response:', response);
        return response;
    },
    error => {
        console.log('Response Error:', error);
        return Promise.reject(error);
    }
);